import * as React from 'react';
import { __ } from 'react-i18n';
import { FlexCol } from '../../Defaults/Flexbox/Flexbox';
import styled from 'styled-components';
import { rem } from 'polished';
import { TitleWithChildren } from '../../Zemplin/General/TitleWithChildren';
import { DsiOptionChooser as OptionChooser } from './OptionChooser/OptionChooser';
import { ZemplinLoaderWrapper } from '../../..';
import { remapDeliveryItem, remapPaymentItem } from './utilities';
import { prop, arrayToObject } from '../../../utilities';
import { InfoText, InfoType } from '../General/InfoText';
import { DpdMapModal } from './DpdMap/DpdMapModal';

interface Props {
  data: any;
  isFetchingDelAndPayInfo: boolean;
  updateCart: any;
  delAndPayInfoById: any;
  isB2B: boolean;
  user: any;
  lang: string;
}

declare global {
  interface Window {
    Packeta: any;
  }
}

function CartDeliveryPart({
  data,
  delAndPayInfoById,
  isFetchingDelAndPayInfo,
  updateCart,
  isB2B,
  user,
  lang,
}: Props) {
  const deliveryId = prop(data, 'delivery.id');
  const paymentId = prop(data, 'payment.id');

  const [isDpdWidgetOpen, setIsDpdWidgetOpen] = React.useState(false);
  const [dpdWidgetDeliveryId, setDpdWidgetDeliveryId] = React.useState(null);

  // React.useEffect(() => {
  //   const handleMessage = event => {
  //     if (event.data.dpdWidget && dpdWidgetDeliveryId) {
  //       if (event.data.dpdWidget.message === 'widgetClose') {
  //         updateCart({ ...data, delivery: null, payment: null });
  //         setIsDpdWidgetOpen(false);
  //       } else {
  //         updateCart({
  //           ...data,
  //           delivery: { dpdWidgetDeliveryId },
  //           payment: null,
  //           dpd_id: event.data.dpdWidget.id,
  //           dpd_payload: event.data.dpdWidget,
  //         });
  //         setIsDpdWidgetOpen(false);
  //       }
  //       setDpdWidgetDeliveryId(null);
  //     }
  //   };
  //   window.addEventListener('message', handleMessage, false);
  //   return () => {
  //     window.removeEventListener('message', handleMessage);
  //   };
  //   // eslint-disable-next-line
  // }, []);

  if (isFetchingDelAndPayInfo) {
    return <ZemplinLoaderWrapper />;
  }
  if (!delAndPayInfoById || Object.keys(delAndPayInfoById).length === 0) {
    return (
      <InfoText
        type={InfoType.ERROR}
        info={__('Nenašiel sa žiadny spôsob dopravy, kontaktuje nás prosím.')}
      />
    );
  }

  const DPD_MAP_TYPE = 'DPD_MAP'; // 'MOCDPD';//'DPD_MAP';

  const ZASIELKOVNA_TYPE = 'ZASIELKOVNA'; // 'MOCDPD';//'DPD_MAP';

  const onChangeDelivery = id => {
    if (id === DPD_MAP_TYPE) {
      setIsDpdWidgetOpen(true);
      setDpdWidgetDeliveryId(id);
    }
    if (prop(data, 'payment.id')) {
      updateCart({ ...data, delivery: { id }, payment: null });
    } else {
      updateCart({ ...data, delivery: { id } });
    }
  };

  const onChangePayment = id => {
    updateCart({ ...data, payment: { id } });
  };

  const deliveryItems = Object.keys(delAndPayInfoById).map(key =>
    remapDeliveryItem(delAndPayInfoById[key], isB2B),
  );

  const currentDeliveryOption = delAndPayInfoById[deliveryId];

  const paymentsById =
    currentDeliveryOption && currentDeliveryOption.payments
      ? arrayToObject(currentDeliveryOption.payments, 'payment_id')
      : [];
  const paymentItems =
    currentDeliveryOption &&
    currentDeliveryOption.payments &&
    currentDeliveryOption.payments.map(payment =>
      remapPaymentItem(payment, isB2B),
    );
  const correctPaymentItems = paymentItems;

  const selectedDelivery = deliveryId
    ? remapDeliveryItem(delAndPayInfoById[deliveryId], isB2B)
    : null;

  const selectedPayment = paymentId
    ? remapPaymentItem(paymentsById[paymentId], isB2B)
    : null;

  const cartProblems = prop(data, 'problems', []);

  if (data.dpd_payload) {
    deliveryItems.forEach((deliveryItem: any) => {
      if (
        data.delivery &&
        data.delivery.id === deliveryItem?.id &&
        deliveryItem?.id === DPD_MAP_TYPE
      ) {
        deliveryItem.desc =
          data.dpd_payload.company + ', ' + data.dpd_payload.city;
      }
    });
  }

  if (data.zasielkovna_payload) {
    deliveryItems.forEach((deliveryItem: any) => {
      if (
        data.delivery &&
        data.delivery?.id === deliveryItem?.id &&
        deliveryItem?.id === ZASIELKOVNA_TYPE
      ) {
        deliveryItem.desc = data.zasielkovna_payload.name;
      }
    });
  }

  // if (window) {
  //   window.addEventListener(
  //     'message',
  //     event => {
  //       if (event.data.dpdWidget && dpdWidgetDeliveryId) {
  //         if (event.data.dpdWidget.message === 'widgetClose') {
  //           updateCart({ ...data, delivery: null, payment: null });
  //           setIsDpdWidgetOpen(false);
  //         } else {
  //           updateCart({
  //             ...data,
  //             delivery: { dpdWidgetDeliveryId },
  //             payment: null,
  //             dpd_id: event.data.dpdWidget.id,
  //             dpd_payload: event.data.dpdWidget,
  //           });
  //           setIsDpdWidgetOpen(false);
  //         }
  //         setDpdWidgetDeliveryId(null);
  //       }
  //     },
  //     false,
  //   );
  // }

  const handleOpenDpdModal = () => {
    if (data.dpd_id) {
      updateCart({
        ...data,
        delivery: { id: dpdWidgetDeliveryId },
        dpd_id: data.dpd_id,
        dpd_payload: data.dpd_payload,
        payment: null,
      });
    } else {
      updateCart({ ...data, delivery: null, payment: null });
    }
    setIsDpdWidgetOpen(false);
  };

  const handleChooseDpdPoint = deliveryPoint => {
    updateCart({
      ...data,
      delivery: { id: dpdWidgetDeliveryId },
      payment: null,
      dpd_id: deliveryPoint.id,
      dpd_payload: deliveryPoint,
    });
    setIsDpdWidgetOpen(false);
  };

  const handleZasielkovna = (deliveryPoint): void => {
    if (deliveryPoint) {
      updateCart({
        ...data,
        delivery: { id: ZASIELKOVNA_TYPE },
        payment: null,
        zasielkovna_id: deliveryPoint?.id,
        zasielkovna_payload: deliveryPoint,
      });
    }
  };

  const openZasielkovna = (showZBox: boolean, showZPoint: boolean): void => {
    const exist = document.getElementById('#packeta');

    if (!exist) {
      const script = document.createElement('script');
      script.src = 'https://widget.packeta.com/www/js/library.js';
      script.id = 'packeta';
      document.body.appendChild(script);

      const vendorsArray: Array<{ country: string; group?: string }> = [];
      if (showZBox) {
        vendorsArray.push({ country: lang, group: 'zbox' });
      }
      if (showZPoint) {
        vendorsArray.push({ country: lang });
      }

      script.onload = () => {
        window.Packeta.Widget.pick(
          process.env.ZASIELKOVNA_API_KEY,
          handleZasielkovna,
          {
            country: lang,
            language: lang,
            vendors: vendorsArray,
          },
        );
      };
    }
  };

  return (
    <Wrapper>
      {/* {cartProblems && cartProblems.length > 0 ? (
        <>
          {cartProblems.map((problem, i) => (
            <>
              {i === 0 ? (
                <InfoText
                  key={problem.readable}
                  maxWidth={1168}
                  type={InfoType.ERROR}
                  info={problem.readable}
                />
              ) : null}
            </>
          ))}
        </>
      ) : null} */}
      <TitleWithChildren title={__('Spôsob dopravy')}>
        <OptionChooser
          items={deliveryItems
            .filter(a => a)
            .filter((deliveryItem: any) => {
              if (
                deliveryItem.id === DPD_MAP_TYPE &&
                (!user || ![149358, 149424, 169247, 181758].includes(user.id))
              ) {
                return false;
              }
              return true;
            })}
          selectedOption={selectedDelivery}
          handleOptionClick={onChangeDelivery}
          handleZasielkovna={openZasielkovna}
        />
      </TitleWithChildren>
      <TitleWithChildren title={__('Spôsob platby')}>
        {correctPaymentItems && correctPaymentItems.length > 0 ? (
          <OptionChooser
            items={correctPaymentItems}
            selectedOption={selectedPayment}
            handleOptionClick={onChangePayment}
          />
        ) : (
          <InfoText
            type={InfoType.INFO}
            info={__('Zvoľte prosím preferovaný spôsob dopravy')}
            noIcon={true}
          />
        )}
      </TitleWithChildren>

      {isDpdWidgetOpen ? (
        <>
          <DpdMapModal
            handleOpen={handleOpenDpdModal}
            handleChoose={handleChooseDpdPoint}
            lang={lang}
            selected={{
              dpd_id: data.dpd_id,
              dpd_payload: data.dpd_payload,
            }}
          />
          {/*
          <iframe src="https://api.dpd.cz/widget/latest/index.html?disableLockers=true" width="100%" height="100%"></iframe>
          */}
        </>
      ) : (
        ''
      )}
    </Wrapper>
  );
}

const Wrapper = styled(FlexCol)`
  width: 100%;
  margin-top: ${rem(56)};
`;

const DPDWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background: white;
`;

export { CartDeliveryPart as DsiCartDeliveryPart };
